import { useEffect, useState } from "react";
import FormBasicInfo from "../formBasicInfo/formBasicInfo";
import ClassificationResult from "./Steps/classificationResult";
import Questions from "./Steps/questions";
import HeaderPage from "../headerPage/headerPage";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getSessionVerify,
  getSessionResume,
  getSessionFinalize,
} from "../../redux/actions/fluxoNSimilar";
import { clearSession } from "../../redux/slices/sessionSlice";
import Modal from "../modalSession/modal";
import Heading from "../fluxo-engenheiro/heading/heading";
import { Skeleton } from "@mui/material";
import { useLocation } from "react-router-dom";
import functionDate from "../../utils/formatarData";
import Textnotifications from "../../utils/notifications";
import { useRoles } from "../../hooks/roles";
import { useSessionHandler } from "../../hooks/useSessionHandler";

const ConfigSteps = () => {
  const [, setStep] = useState(1);
  const [questionsTrue, setQuestionsTrue] = useState(false);
  const [originalQuestions, setOriginalQuestions] = useState<any | null>(null);
  const [getPartNumber, setGetPartNumber] = useState<any | null>(null);
  const [displayTableAtributes, setDisplayTableAtributes] = useState<
    any | null
  >(false);
  const { sessionInfo } = useSelector((state: RootState) => state.sessionInfo);
  const [getSessionId, setGetSessionId] = useState("");
  const [, setGetTimeStamp] = useState("");
  const [getNcm, setGetNcm] = useState({
    ncm: "",
    pn: "",
  });
  const [getLastQuestions, setGetLastQuestions] = useState<any>(null);
  const [modalDispplay, setModalDisplay] = useState(false);
  const [modalProduct, setModalProduct] = useState<any>(null);
  const [modalDesc, setModalDesc] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [isBanner, setIsBanner] = useState(false);
  const [pnSimilarSelect, setPnSimilarSelect] = useState(
    localStorage.getItem("selectValue") === "Sim" ||
      isBanner === true ||
      isBanner === false
      ? "Sim"
      : "Não"
  );
  const { isEngineer } = useRoles();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.startAtStep === "questions") {
      setQuestionsTrue(true);
    }
  }, [location.state]);

  const dispatch = useDispatch<AppDispatch>();

  const { sessionVerify, httpStatus } = useSelector(
    (state: RootState) => state.sessionInfo
  );

  const { sessionQuestions } = useSelector(
    (state: RootState) => state.sessionMetadata
  );

  useEffect(() => {
    setGetSessionId(sessionInfo?.message?.sessionId);
  }, [sessionInfo]);

  useEffect(() => {
    const fetchSessionVerify = async () => {
      try {
        localStorage.removeItem("finalizedSession");
        await dispatch(getSessionVerify()).unwrap();
      } catch (error) {
        console.error("Erro ao verificar sessão:", error);
      }
    };

    const fetchSessionVerifyPn = async () => {
      try {
        localStorage.removeItem("finalizedSession");
        setLoading(true);

        if (sessionVerify.httpStatus !== 204) {
          await dispatch(getSessionResume(sessionVerify.sessionId)).unwrap();
        }
      } catch (error) {
        setIsBanner(false);
        console.error("Erro ao buscar sessão por PN:", error);
      } finally {
        setLoading(false);
      }
    };

    if (sessionVerify.pnNumber !== true) {
      fetchSessionVerify();
    } else {
      fetchSessionVerifyPn();
    }
  }, []);

  useEffect(() => {
    if (
      httpStatus === 200 &&
      pnSimilarSelect !== "Não" &&
      sessionVerify?.isSimilar === true
    ) {
      setIsBanner(true);
    }
  }, [httpStatus, pnSimilarSelect]);

  const handleResetBanner = () => {
    setIsBanner(false);
  };

  useSessionHandler({
    sessionVerify,
    setLoading,
    setModalDisplay,
    setModalProduct,
    setModalDesc,
  });

  useEffect(() => {
    if (Array.isArray(sessionQuestions) && sessionQuestions.length > 0) {
      const lastQuestion = sessionQuestions[sessionQuestions.length - 1];
      setGetLastQuestions(lastQuestion);
    }
  }, [sessionQuestions]);

  const gotToOutStep = () => setStep((prevStep) => prevStep - 1);
  const getIsoTimestamp = () => {
    setGetTimeStamp(new Date().toISOString());
  };

  useEffect(() => {
    if (sessionInfo?.message == null) {
      getIsoTimestamp();
    }
  }, [sessionInfo?.message]);

  return (
    <div className="pages">
      {loading && (
        <div
          style={{
            marginTop: 20,
            marginLeft: 50,
            display: "flex",
            width: 600,
          }}
        >
          <div>
            <Skeleton
              variant="rectangular"
              width={305}
              height={58}
              style={{ marginRight: 20 }}
            />
            <br />
            <Skeleton variant="rectangular" width={305} height={58} />
            <br />
          </div>
          <div>
            <Skeleton
              variant="rectangular"
              width={305}
              height={58}
              style={{ marginRight: 20 }}
            />
            <br />
            <Skeleton variant="rectangular" width={305} height={58} />
            <br />
          </div>
        </div>
      )}

      {questionsTrue === false && !loading && (
        <div>
          <div className="upperPerguntas">
            <Heading
              titlePage="Emissão de Laudo"
              blockText="sim"
              text1="Preencha os dados abaixo para a emissão do laudo."
              text2="Para facilitar a análise pelo aprovador, anexe imagens ou documentos e revise as informações com atenção — após a confirmação, os arquivos não poderão ser editados ou removidos."
              text3=""
              isBanner={isBanner}
            />
          </div>
          <FormBasicInfo
            setQuestionsTrue={setQuestionsTrue}
            setOriginalQuestions={setOriginalQuestions}
            setGetPartNumber={setGetPartNumber}
            timeStamp={getIsoTimestamp}
            setPnSimilarSelect={setPnSimilarSelect}
            pnSimilarSelect={pnSimilarSelect}
            setIsBanner={setIsBanner}
          />
        </div>
      )}
      {questionsTrue === true && !displayTableAtributes && (
        <>
          <div className="upperPerguntas">
            <Heading
              className="titleR"
              titlePage="Responda algumas perguntas"
              blockText="sim"
              detalsIA="sim"
              isBanner={isBanner}
            />
          </div>
          <HeaderPage
            title="Criando Part Number:"
            numberPartNumber={modalProduct || getPartNumber}
          />
          <Questions
            infos={originalQuestions}
            timeStamp={getIsoTimestamp}
            setDisplayTableAtributes={setDisplayTableAtributes}
            setGetSessionId={setGetSessionId}
            sessionQuestions={sessionQuestions}
            getLastQuestions={getLastQuestions}
            pnSimilarSelect={pnSimilarSelect}
          />
        </>
      )}

      {displayTableAtributes && questionsTrue === true && (
        <>
          <div className="upperPerguntas">
            <Heading
              titlePage="Visualizar dados preenchidos"
              blockText="sim"
              getSessionId={getSessionId}
              isBanner={isBanner}
            />
          </div>

          <HeaderPage
            title="Criando Part Number:"
            numberPartNumber={modalProduct || getPartNumber}
            nameNCM="NCM:"
            numberNCM={getNcm.ncm}
          />
          <ClassificationResult
            onConfirm={gotToOutStep}
            getSessionId={getSessionId}
            setQuestionsTrue={setQuestionsTrue}
            setGetNcm={setGetNcm}
            setDisplayTableAtributes={setDisplayTableAtributes}
            onFinalizeClassification={handleResetBanner}
          />
        </>
      )}

      {modalDispplay && isEngineer && (
        <Modal
          className="widthCustom"
          classNameAux="lastButton"
          titleModal="Aviso"
          titleDescription={
            <div
              className="titleDescription"
              dangerouslySetInnerHTML={{
                __html: functionDate.formatKey(
                  Textnotifications.bodyTextTitle()
                ),
              }}
            />
          }
          onCloseX={() => {
            setGetPartNumber("");
            setModalProduct("");
            setModalDisplay(false);
            setLoading(false);
            dispatch(clearSession());
          }}
          bodyModal={
            <div
              dangerouslySetInnerHTML={{
                __html: functionDate.formatKey(
                  Textnotifications.bodyText(modalProduct, modalDesc)
                ),
              }}
            />
          }
          buttonOne="Retomar"
          onConfirm={async () => {
            await dispatch(getSessionResume(sessionVerify.sessionId));
            setQuestionsTrue(true);
            setModalDisplay(false);
            setLoading(false);
          }}
          buttonTwo="Descartar"
          onClose={() => {
            dispatch(getSessionFinalize(sessionVerify.sessionId));
            setModalDisplay(false);
            setQuestionsTrue(false);
            setTimeout(() => {
              globalThis.location.reload();
            }, 350);
          }}
          buttonFour="Continuar depois"
          setModalDisplay={setModalDisplay}
          setLoading={setLoading}
        />
      )}
    
    </div>
    
  );
};

export default ConfigSteps;
